import { render, staticRenderFns } from "./Ponuda.vue?vue&type=template&id=971efadc"
import script from "./Ponuda.vue?vue&type=script&lang=js"
export * from "./Ponuda.vue?vue&type=script&lang=js"
import style0 from "./Ponuda.vue?vue&type=style&index=0&id=971efadc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports